import React from 'react'
import { IconProps, IconWrapper } from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d='M9.1665 7.33325L12.8332 10.9999L9.1665 14.6666'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
    />
)

export const ArrowChevronRight: React.FC<IconProps> = ({ color, size }) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{ size, color }} renderIcon={renderIcon} />
)
